module.exports = __webpack_public_path__ + "static/opened_logo-7cdeff1a5a036b0b29798e92314157cc.png";